import {
  CreateReviewInput,
  UpdateReviewInput,
  useCreateReviewMutation,
  useUpdateReviewMutation,
} from 'lib/gql'
import { useCallback } from 'react'

export const useSubmitReview = (orderId: string, reviewId: string | null) => {
  const [
    { error: createReviewError, fetching: createReviewFetching },
    createReview,
  ] = useCreateReviewMutation()
  const [
    { error: updateReviewError, fetching: updateReviewFetching },
    updateReview,
  ] = useUpdateReviewMutation()

  const submitReview = useCallback(
    async ({
      rating,
      notes,
    }: Pick<CreateReviewInput | UpdateReviewInput, 'notes' | 'rating'>) => {
      if (reviewId) {
        return await updateReview({ input: { rating, notes, reviewId } })
      } else {
        return await createReview({ input: { rating, notes, orderId } })
      }
    },
    [orderId, reviewId, createReview, updateReview],
  )

  return {
    submitReview,
    error: createReviewError || updateReviewError,
    mutating: createReviewFetching || updateReviewFetching,
  }
}
